var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLefticon = function SvgChevronLefticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.573 2.677a.25.25 0 0 1 .354 0l.701.701a.25.25 0 0 1 0 .354L6.36 8l4.268 4.268a.25.25 0 0 1 0 .354l-.701.701a.25.25 0 0 1-.354 0L4.427 8.177a.25.25 0 0 1 0-.354l5.146-5.146Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLefticon;